import { render, staticRenderFns } from "./AssetVehicleForm.vue?vue&type=template&id=aff5158a&scoped=true&"
import script from "./AssetVehicleForm.vue?vue&type=script&lang=ts&"
export * from "./AssetVehicleForm.vue?vue&type=script&lang=ts&"
import style0 from "./AssetVehicleForm.vue?vue&type=style&index=0&id=aff5158a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff5158a",
  null
  
)

export default component.exports